<app-item-base [open]="open">
  <p class="name" placement="right">
    開始
  </p>
  <div class="edit-field" style="width: 11rem;">
    <select class="" [(ngModel)]="searchParams.begin_from" (ngModelChange)="beginFrom=parseDate($event)"
      name="begin_from">
      <option [ngValue]=null>-</option>
      <option *ngFor="let d of DatesFrom" [ngValue]="d.dateString" [disabled]="optionUnAvailable(d.realDate, beginTo)">
        {{d.monthNumber}}月</option>
    </select>
    ~
    <select class="" [(ngModel)]="searchParams.begin_to" (ngModelChange)="beginTo=parseDate($event)" name="begin_to">
      <option [ngValue]=null>-</option>
      <option *ngFor="let d of DatesTo" [ngValue]="d.dateString" [disabled]="optionUnAvailable(beginFrom, d.realDate)">
        {{d.monthNumber}}月</option>
    </select>
  </div>

  <input class="edit-field" type="checkbox" placement="right"
    [checked]="!this.searchParams.begin_null" (change)="this.searchParams.begin_null = !this.searchParams.begin_null" />
</app-item-base>